<template>
  <section
    v-if="bundles.length > 0"
    class="tw-w-full tw-text-gray-800 tw-pt-3 lg:tw-pt-4"
  >
    <div class="tw-relative tw-h-full">
      <div class="lg:tw-flex md:tw-flex-wrap tw-items-baseline">
        <h2 class="tw-text-red-500 lg:tw-text-xl md:tw-text-l tw-mb-1">
          {{ data.bundle.headline }}
        </h2>
        <div class="tw-w-full">
          <p class="tw-mb-2 lg:tw-mb-3">
            {{ data.bundle.subheadline }}
          </p>
        </div>
      </div>
      <div class="drawings tw-pb-3">
        <ul class="drawings__slider tw-flex tw-flex-col md:tw-flex-row">
          <li
            tabindex="0"
            v-for="(bundle, index) in bundles"
            :key="index"
            :class="[
              { 'is-checked': bundle.isSelected },
              { 'not-checked': !bundle.isSelected }
            ]"
            @click="onclickBundle(bundle)"
            @keydown.space.prevent.stop="onclickBundle(bundle)"
            class="drawings__slider__slide tw-cursor-pointer tw-flex-1 tw-flex tw-w-full md:tw-w-auto"
          >
            <div
              class="drawings__level tw-text-base tw-cursor-pointer tw-w-full tw-text-l tw-flex tw-flex-col"
            >
              <div
                class="drawings__level__body tw-ml-2 tw-mt-3 tw-mb-1 tw-flex tw-flex-col tw-flex-1"
                :class="bundleOpened ? 'tw-mb-2' : ''"
              >
                <p class="font-bold tw-flex">
                  <select-indicator
                    :selected="bundle.isSelected"
                    class="drawings__level__indicator tw-mr-1 tw-self-center"
                  />
                  <span class="drawings__level__one-time tw-text-l">
                    {{ bundle.name }}
                  </span>
                </p>
                <template v-if="!bundleOpened">
                  <ul class="tw-mt-2 tw-flex-1">
                    <li
                      v-for="(bulletPoint,
                      bulletPointIndex) in bundle.bulletPoints"
                      :key="bulletPointIndex"
                      class="tw-flex tw-mb-1"
                    >
                      <span
                        class="tw-text-green-500 tw-mr-1 tw-flex tw-icon tw-icon-haken-bold"
                      ></span>
                      <span class="tw-text-base tw-self-center">{{
                        bulletPoint
                      }}</span>
                    </li>
                  </ul>
                  <a
                    href=""
                    class="hover:tw-no-underline tw-flex tw-items-center tw-w-full tw-text-m"
                    @click.prevent.stop="
                      openDetailModal(bundle.categories, $event)
                    "
                    @keydown.space.prevent.stop="
                      openDetailModal(bundle.categories, $event)
                    "
                  >
                    <span
                      class="tw-icon-weiter-top-bold tw-align-middle tw-icon tw-transform tw-rotate-90 text-l"
                    ></span>
                    alle Gewinndetails anzeigen
                  </a>
                </template>
              </div>
              <p
                class="drawings__level__price tw-text-s tw-text-grey-800 tw-leading-xl tw-text-center"
              >
                <span class="font-bold tw-block tw-text-base tw-mb-1/2">
                  {{ bundle.winChanceText }}
                </span>
                <span class="font-bold tw-pr-1 tw-text-l"
                  >{{ bundle.prize }}
                  <abbr title="Euro" role="presentation">€</abbr>
                </span>
                <span class="tw-text-l">pro Monat</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <a
        href=""
        class="hover:tw-no-underline tw-flex tw-items-center tw-w-full"
        @click.prevent="toggleBundleScheme"
        @keydown.space="toggleBundleScheme"
      >
        <span
          class="
              tw-icon-weiter-top-bold
              tw-align-middle tw-icon
              tw-transform tw-rotate-90
              tw-text-xl
            "
        ></span>
        {{ bundleOpened ? data.bundle.closeLabel : data.bundle.openLabel }}
      </a>
    </div>
    <Modal ref="bundleModal" :fit-content="true" :autoheight="true">
      <template #default>
        <h1
          class="tw-text-l md:tw-text-xl tw-mb-2 md:tw-mb-4 md:tw-text-center"
        >
          {{ data.bundle.modal.headline }}
        </h1>
        <div
          class="modal-content-scrollable md:tw-flex-row tw-flex tw-flex-col md:tw-justify-center md:tw-gap-3"
        >
          <div
            v-for="(category, index) in modalCategories"
            :key="index"
            class="md:tw-mb-0 tw-flex tw-flex-col"
            :class="index + 1 == modalCategories.length ? 'tw-mb-0' : 'tw-mb-3'"
          >
            <span
              class="tw-text-base md:tw-text-l tw-mb-1 md:tw-mb-2 tw-block md:tw-text-center"
            >
              {{ category.name }}
            </span>
            <div class="tw-bg-grey-100 tw-rounded-xl tw-p-2 tw-flex-1">
              <div
                v-for="(rank, rankIndex) in category.ranks"
                :key="rankIndex"
                class="tw-mb-1 md:tw-mb-2 tw-last:tw-mb-0"
                :class="rankIndex == 0 ? 'tw-mt-2' : ''"
              >
                <div class="tw-flex tw-justify-center">
                  <div
                    class="rank-content tw-flex tw-flex-row tw-justify-end md:tw-flex-col"
                  >
                    <div
                      class="font-bold tw-text-base md:tw-text-l tw-mr-1 md:tw-mr-0 tw-text-right md:tw-text-center"
                    >
                      <template
                        v-if="
                          rank.oneTimeWinningSum > 0 &&
                            rank.monthlyWinningSum > 0
                        "
                      >
                        {{ formatCurrency(rank.oneTimeWinningSum) }} € +
                        <span class="tw-text-base tw-block md:tw-text-l"
                          >{{ formatCurrency(rank.monthlyWinningSum) }} €
                          mtl.</span
                        >
                      </template>
                      <template v-else-if="rank.oneTimeWinningSum > 0">
                        {{ formatCurrency(rank.oneTimeWinningSum) }} €
                      </template>
                      <template v-else-if="rank.monthlyWinningSum > 0">
                        {{ formatCurrency(rank.monthlyWinningSum) }} € mtl.
                      </template>
                    </div>
                    <div
                      class="tw-text-m md:tw-text-base md:tw-text-center md:tw-mt-1"
                    >
                      {{ formatWinningText(rank) }}
                    </div>
                  </div>
                </div>

                <hr
                  v-if="rankIndex + 1 < category.ranks.length"
                  class="tw-text-grey-300 tw-mt-2 tw-mx-auto tw-w-1/2 tw-border-t tw-border-b tw-hidden md:tw-block"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="data.bundle.modal.description"
          class="modal-content-description tw-text-m md:tw-text-base tw-mt-2"
          :style="descriptionStyle()"
        >
          {{ data.bundle.modal.description }}
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import SelectIndicator from './SelectIndicator';
import Modal from './Modal';

export default {
  components: { SelectIndicator, Modal },
  props: {
    bundles: {
      type: Array,
      required: false,
      default: () => []
    },
    isBundleToggled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  created() {
    if (this.data.editModeEnabled === false) {
      const firstSelectedBundle = this.bundles.find(
        (bundle) => bundle.isSelected
      );
      if (firstSelectedBundle) {
        this.onclickBundle(firstSelectedBundle);
      }
    }
  },

  data() {
    return {
      bundleOpened: this.isBundleToggled,
      modalCategories: [],
      windowWidth: window.innerWidth
    };
  },

  watch: {
    isBundleToggled(newValue) {
      this.bundleOpened = newValue;
    }
  },

  methods: {
    descriptionStyle() {
      const width =
        this.modalCategories.length * 200 +
        24 * (this.modalCategories.length - 1);
      return { maxWidth: `${width}px` };
    },

    openDetailModal(categories, event) {
      this.modalCategories = this.getWinningCategoryDetails(categories);
      this.$refs.bundleModal.openModal(event ? event.currentTarget : null);
    },

    getWinningCategoryDetails(categories) {
      const details = [];

      this.data.categoryAreaContent.forEach((category) => {
        if (category.type !== 'WinningCategory') {
          return;
        }

        category.levels.forEach((level) => {
          if (categories.includes(level.productMatrixValue)) {
            details.push({
              name: category.name,
              ranks: level.ranks
            });
          }
        });
      });

      return details;
    },

    formatCurrency(amount) {
      return this.$formatPrice(amount, true, true);
    },

    formatWinningText(rank) {
      return rank.winningPlanText
        .replace('{endziffern}', rank.winningDigits.toString())
        .replace('{gewinner}', rank.numberOfWinners.toString());
    },

    toggleBundleScheme() {
      this.bundleOpened = !this.bundleOpened;
      this.$emit('bundleToggled', this.bundleOpened);
    },

    onclickBundle(bundle) {
      const bundleIndex = this.bundles.indexOf(bundle) + 1; // Get the 1-based index of the bundle
      const totalBundles = this.bundles.length; // Get the total number of bundles
      this.trackClick(
        `pk_lotterie-konfi_bundel_${bundleIndex}-${totalBundles}`
      );
      this.bundles.forEach((b) => {
        b.isSelected = false;
      });
      bundle.isSelected = true;

      // Unselect all levels (except name === 'Zusatzspiel')
      this.data.categoryAreaContent.forEach((category) => {
        if (category.type === 'WinningCategory' && category.name !== 'Zusatzspiel') {
          category.levels.forEach((level) => {
            level.isSelected = false;
            level.isSelectedMobile = false;
          });
        }
      });

      // Reselect only those with matching productMatrixValue (except name === 'Zusatzspiel')
      this.data.categoryAreaContent.forEach((category) => {
        if (category.type !== 'WinningCategory' || category.name === 'Zusatzspiel') {
          return;
        }

        category.levels.forEach((level) => {
          if (bundle.categories.includes(level.productMatrixValue)) {
            level.isSelected = true;
            level.isSelectedMobile = true;
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../sass/mixins';

.rank-content {
  @media (max-width: calc(theme('screens.md') - 1px)) {
    width: px-to-rem(192px);
  }
}

.drawings {
  &__level {
    &__body {
      & > ul {
        .tw-icon {
          font-size: px-to-rem(36px);
          width: px-to-rem(24px);
          height: px-to-rem(24px);
          @apply tw-flex tw-items-center tw-justify-center;
        }
      }
    }

    &__price {
      @apply tw-block tw-text-center;
      padding: px-to-rem(12px) px-to-rem(4px);
      margin: 0 px-to-rem(4px) px-to-rem(4px) px-to-rem(4px);
    }
  }

  &__slider {
    @apply tw-w-auto tw-flex-wrap;
    gap: px-to-rem(16px);

    @media (max-width: calc(theme('screens.lg') - 1px)) {
      & > li {
        flex: 1 1 100%;
        max-width: 100%;
      }
    }

    @media (min-width: theme('screens.lg')) and (max-width: calc(theme('screens.xl') - 1px)) {
      & > li {
        flex: 1 1 calc(50% - #{px-to-rem(8.5px)});
        max-width: calc(50% - #{px-to-rem(8.5px)});
      }
    }
  }
}
</style>
